import { getHLRecordViewer} from 'service-lib';

const getTPLRecordViewer = (viewerName, serviceName, recordId, reduxId, serviceMap, resultPath="result", widerForm=false) => {
    return getHLRecordViewer(viewerName, serviceName, recordId, reduxId, serviceMap, resultPath, 'tpl', widerForm)
}
export default getTPLRecordViewer;
